import React, { useState } from "react";
import "../styles/InfoPanels.css";

const FAQ_ITEMS = [
  {
    q: "How do I mark attendance?",
    a: "Navigate to the Attendance section from the sidebar, then click 'Mark Attendance'. Ensure you have camera access and location enabled (if geofencing is active).",
  },
  {
    q: "Why is my attendance photo not being accepted?",
    a: "The system uses face verification. Make sure the live capture is well-lit, your face is clearly visible, and matches your uploaded profile photo.",
  },
  {
    q: "How do I change my password?",
    a: "Go to Settings → Change Password. This feature will be available once the admin enables it. Contact your administrator for password resets.",
  },
  {
    q: "I'm unable to upload images. What should I do?",
    a: "Ensure the file is in JPEG, PNG, or WebP format. The admin may have configured maximum file size limits under Theme settings. Try reducing the image quality or contact your admin.",
  },
  {
    q: "Who can I contact for technical issues?",
    a: "Reach out to your organization's system administrator. If the issue persists, use the contact form below or email the support address provided by your admin.",
  },
  {
    q: "What browsers are supported?",
    a: "Girinestham works best on the latest versions of Chrome, Firefox, Safari, and Edge. For mobile, use the device's built-in browser.",
  },
];

export default function HelpSupportPanel() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="info-panel">
      <div className="info-panel__mesh" aria-hidden />

      <header className="info-panel__header">
        <p className="info-panel__eyebrow">Support</p>
        <h2 className="info-panel__title">Help & Support</h2>
        <p className="info-panel__sub">
          Find answers to common questions or reach out for assistance.
        </p>
      </header>

      <section className="info-panel__section">
        <h3 className="info-panel__section-title">Frequently Asked Questions</h3>
        <div className="info-panel__faq-list">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <button
                type="button"
                key={i}
                className={`info-panel__faq${isOpen ? " is-open" : ""}`}
                onClick={() => setOpenIndex(isOpen ? null : i)}
                aria-expanded={isOpen}
              >
                <span className="info-panel__faq-q">
                  <span>{item.q}</span>
                  <span className="info-panel__faq-chevron">{isOpen ? "−" : "+"}</span>
                </span>
                {isOpen && <span className="info-panel__faq-a">{item.a}</span>}
              </button>
            );
          })}
        </div>
      </section>

      <section className="info-panel__section">
        <h3 className="info-panel__section-title">Contact Support</h3>
        <div className="info-panel__contact-grid">
          <div className="info-panel__contact-card">
            <span className="info-panel__contact-icon">✉</span>
            <strong>Email</strong>
            <span>support@girinestham.com</span>
          </div>
          <div className="info-panel__contact-card">
            <span className="info-panel__contact-icon">☎</span>
            <strong>Phone</strong>
            <span>Contact your administrator</span>
          </div>
          <div className="info-panel__contact-card">
            <span className="info-panel__contact-icon">⏰</span>
            <strong>Availability</strong>
            <span>Mon – Sat, 9 AM – 6 PM</span>
          </div>
        </div>
      </section>
    </div>
  );
}
